import classNames from "classnames";

import { isEmailInvalid } from "../../utils/helpers";

import style from "./Avatar.module.css";

export const getInitials = (identifier?: string): string => {
  if (!identifier) return "";

  identifier = identifier.trim();
  if (!isEmailInvalid(identifier)) {
    identifier = identifier.split("@")[0];
  }

  const separators: RegExp[] = [/\s+/, /\.+/, /_+/, /-+/];

  let parts = [identifier];
  for (const re of separators) {
    if (re.test(identifier)) {
      parts = identifier.split(re).filter(Boolean);
      break;
    }
  }

  const [a, b] = parts.slice(0, 2);
  return (
    (a ? String.fromCodePoint(a.codePointAt(0) ?? 0) : "").toUpperCase() +
    (b ? String.fromCodePoint(b.codePointAt(0) ?? 0) : "").toUpperCase()
  );
};

interface AvatarProps {
  title: string;
  disabled?: boolean;
}

export const Avatar = ({ title, disabled }: AvatarProps) => {
  return (
    <div className={classNames(style.avatarWrapper, disabled && style.disabled)}>
      {getInitials(title)}
    </div>
  );
};
